<template>
    <div class="review-list">
        <div v-for="(item, key) in items" :id="item.editAreaId" :key="key" class="review-list__item">
            <div class="r-review">
                <div class="r-review__top">
                    <div class="r-review__top-name">{{ item.NAME }}</div>
                    <div class="r-review__top-date">{{ item.ACTIVE_FROM }}</div>
                </div>
                <div class="r-review__text" v-html="item.DETAIL_TEXT" ></div>
                <a v-if="item.photo && item.photo.src" class="r-review__photo" :href="item.photo_big.src" data-fancybox >
                    <img :src="item.photo.src" loading="lazy" />
                </a>
            </div>
            <div v-if="item.PROPERTIES.ADMIN_RESPONSE.VALUE" class="r-answer">
                <div class="r-answer__top">
                    <div class="r-answer__top-name">Администратор</div>
                    <div class="r-answer__top-date">{{ item.PROPERTIES.RESPONSE_DATE_UPDATE.VALUE }}</div>
                </div>
                <div class="r-answer__text">
                    <p>{{ item.PROPERTIES.ADMIN_RESPONSE.VALUE }}</p>
                </div>
            </div>
        </div>
        <div v-if="!all" @click="loadMore" class="review-btn btn">Загрузить еще</div>
    </div>
</template>

<script>
export default {
    name : "ReviewsList",
    props: {
        all_prop  : Boolean,
        nav_num   : Number,
        items_prop: Array,
    },
    data() {
        return {
            page : 2,
            items: [],
            all  : false,
        }
    },
    methods: {
        loadMore() {
            let query = (document.location.search === '' ? '?' : '&') + 'pagination=Y&PAGEN_' + this.nav_num + '=' + this.page;
            fetch(document.location.href + query, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(result => {
                    if(result.pages <= this.page)
                        this.all = true;
                    if(result.data.length > 0)
                        for(let item in result.data)
                            this.items.push(result.data[item]);
                    this.page++;
                })
        }
    },
    created() {
        this.all = this.all_prop;
        for(let item of this.items_prop)
            this.items.push(item);
    }
}
</script>

<style scoped>

</style>